import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { TextBody, IconTime, IconClose, IconSearch, IconButton } from 'blocket-ui'

const defaultCgLabel = 'Alla kategorier'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ hasCategory }) => (hasCategory ? '44' : '36')}px;
  padding: 6px 6px 6px 16px;
  text-align: left;
  cursor: pointer;

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: #f9f7f6;
    `}
`

const LeftContentWrapper = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 48px);
`

export const HistoryIcon = styled(IconTime)`
  margin-right: 14px;
  flex-shrink: 0;
  margin-left: -1px;
`

export const SearchIcon = styled(IconSearch)`
  margin-right: 14px;
  flex-shrink: 0;
  margin-left: -1px;
`

export const StyledTextBody = styled(TextBody)`
  white-space: pre;
`

export const SubHeading = styled.p`
  padding-right: 10px;
  font-size: 17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre;
`

export const CategoryText = styled.p`
  font-family: BlocketSans-Regular, sans-serif;
  font-size: 14px;
  color: #696766;
`

export const StyledIconClose = styled(IconClose)`` // Needed to be able to style on hover. See line 77

export const StyledClearButton = styled(IconButton)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 48px;
  cursor: pointer;
  &:hover ${StyledIconClose} {
    color: #000;
  }
`

const ColumnTextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-family: BlocketSans-Medium, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`

const RowTextWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
`

// split the query in one part that matches the userQuery
// and another part with the rest
const getTextParts = (query, userQuery) => {
  let normalText = ''
  let boldText = query

  if (query.startsWith(userQuery.toLowerCase())) {
    normalText = query.substr(0, userQuery.length)
    boldText = query.substr(userQuery.length)
  }

  return { normalText, boldText }
}

const icon = <StyledIconClose width={24} height={24} />

const Suggestion = ({
  suggestion: { q, cg, cgLabel, history },
  handleRemove,
  userQuery,
  isHighlighted,
}) => {
  const { normalText, boldText } = getTextParts(q, userQuery)

  const clickHandler = useCallback(
    (e) => {
      return handleRemove(e, q, cg)
    },
    [handleRemove, q, cg],
  )

  return (
    <Wrapper isHighlighted={isHighlighted} hasCategory={cgLabel || history}>
      <LeftContentWrapper>
        {history ? (
          <HistoryIcon height={16} width={16} color="#696766" />
        ) : (
          <SearchIcon height={16} width={16} color="#696766" />
        )}
        <ColumnTextWrapper>
          <RowTextWrapper>
            {normalText && <StyledTextBody tagName="p">{normalText}</StyledTextBody>}
            <SubHeading id={history && 'history-suggestion-word'}>
              <strong>{boldText}</strong>
            </SubHeading>
          </RowTextWrapper>
          {(cgLabel || history) && (
            <CategoryText>
              <small>{cgLabel || defaultCgLabel}</small>
            </CategoryText>
          )}
        </ColumnTextWrapper>
      </LeftContentWrapper>
      {history && (
        <StyledClearButton
          icon={icon}
          activeIcon={icon}
          style={{ backgroundColor: 'transparent' }}
          onClick={clickHandler}
        />
      )}
    </Wrapper>
  )
}

export default Suggestion

Suggestion.propTypes = {
  suggestion: PropTypes.shape({
    q: PropTypes.string.isRequired,
    cg: PropTypes.string,
    cgLabel: PropTypes.string,
    history: PropTypes.bool,
  }).isRequired,
  handleRemove: PropTypes.func,
  userQuery: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool,
}
